import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";

const Modal = ({
  target,
  title,
  size,
  show,
  onHide,
  children,
  backdrop = "static",
  keyboard = false,
}) => {
  useEffect(() => {
    const modalElement = document.getElementById(target);
    if (!modalElement) {
      console.error(`Modal target element with ID "${target}" not found.`);
      return;
    }

    const ensureReadyAndToggle = () => {
      // Wait until the dialog node is present to avoid Bootstrap reading style of null
      if (!modalElement.querySelector(".modal-dialog")) {
        setTimeout(ensureReadyAndToggle, 0);
        return;
      }
      if (!(window.bootstrap && window.bootstrap.Modal)) {
        console.error(
          "Bootstrap Modal is not available. Make sure Bootstrap JS is loaded correctly.",
        );
        return;
      }
      const instance = window.bootstrap.Modal.getOrCreateInstance(modalElement);
      try {
        if (show) instance.show();
        else instance.hide();
      } catch (e) {
        console.warn("Modal toggle error (ignored):", e);
      }
    };

    // Defer to next tick so children render first
    setTimeout(ensureReadyAndToggle, 0);

    return () => {
      try {
        const inst = window.bootstrap?.Modal?.getInstance(modalElement);
        // Do not dispose in cleanup to avoid race with external toggles; just hide
        inst?.hide();
      } catch {}
    };
  }, [show, target]);

  return (
    <div
      className="modal fade"
      id={target}
      tabIndex="-1"
      data-bs-backdrop={backdrop}
      data-bs-keyboard={keyboard}
    >
      <div className={`modal-dialog modal-dialog-scrollable ${size || ""}`}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
